import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode } from 'react'

import styles from './Drawer.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  className?: string
}

export const Drawer = ({ isOpen, onClose, children, className }: Props) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.backdrop}
          onClick={handleBackdropClick}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className={className ? `${styles.panel} ${className}` : styles.panel}
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={styles.closeButton} onClick={onClose}>
              <svg viewBox="0 0 20 20" fill="none">
                <line x1="3.8" y1="4.1" x2="15.9" y2="16.1" stroke="white" />
                <line x1="15.9" y1="3.9" x2="3.8" y2="15.9" stroke="white" />
              </svg>
            </button>
            <div className={styles.content}>{children}</div>
            {/* <div className={styles.homeIndicator} /> */}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
